<template>
  <div class="app-calendar overflow-hidden border p-0 col-sm-12">
    <div class="row no-gutters">
      <!-- Sidebar -->
      <div
        v-if="user.role === 'admin'"
        class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
        :class="{ show: orderForm.show }"
      >
        <calendar-sidebar @onNewEvent="addTask()" />
      </div>
      <calendar-change-status />

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0">
            <calendar />
          </div>
        </div>
      </div>

      <!-- Sidebar Overlay -->
      <div class="body-content-overlay" @click="() => {}" />
      <CalendarForm @onClose="closeTask()" />
    </div>
  </div>
</template>

<script>
import CalendarSidebar from "@/components/Calendar/calendar-sidebar/CalendarSidebar.vue";
import CalendarChangeStatus from "@/components/Calendar/CalendarChangeStatus.vue";

// components
import CalendarForm from "@/components/Calendar/CalendarForm";
import Calendar from "@/components/Calendar/Calendar";

// vuex
import { mapActions, mapState } from "vuex";

export default {
  name: "CalendarView",
  components: {
    CalendarSidebar,
    CalendarChangeStatus,
    CalendarForm,
    Calendar
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("orders", ["orderForm"]),
    ...mapState("auth", ["user"])
  },
  mounted() {
    this.resetTasks().then(() => {
      this.init();
    });
  },
  beforeDestroy() {
    this.resetTasks();
  },
  methods: {
    ...mapActions("orders", ["getTasks", "addTask", "closeTask", "resetTasks"]),
    ...mapActions("customers", ["getCustomers"]),
    ...mapActions("services", ["getServices"]),
    ...mapActions("users", ["getUsers"]),
    async init() {
      if (this.user.role === "admin") {
        // this.getTasks()
        this.getCustomers({ perPage: Number.MAX_SAFE_INTEGER });
        this.getServices();
        this.getUsers();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
